var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.8671C1 15.9342 4.33787 12.746 11.1587 12.746C17.9796 12.746 21.3175 15.9342 21.3175 19.8671C21.3175 20.4928 20.8537 21 20.2817 21H2.03579C1.46374 21 1 20.4928 1 19.8671Z",
    fill: "#706D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9683 4.75C14.9683 6.82107 13.2627 8.5 11.1587 8.5C9.05479 8.5 7.34921 6.82107 7.34921 4.75C7.34921 2.67893 9.05479 1 11.1587 1C13.2627 1 14.9683 2.67893 14.9683 4.75Z",
    fill: "#706D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.8671C1 15.9342 4.33787 12.746 11.1587 12.746C17.9796 12.746 21.3175 15.9342 21.3175 19.8671C21.3175 20.4928 20.8537 21 20.2817 21H2.03579C1.46374 21 1 20.4928 1 19.8671Z",
    stroke: "#706D9D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9683 4.75C14.9683 6.82107 13.2627 8.5 11.1587 8.5C9.05479 8.5 7.34921 6.82107 7.34921 4.75C7.34921 2.67893 9.05479 1 11.1587 1C13.2627 1 14.9683 2.67893 14.9683 4.75Z",
    stroke: "#706D9D",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 9.57143L19.1485 11L24.3337 6",
    stroke: "#706D9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlist);
export default __webpack_public_path__ + "static/media/shortlist.18076e79f8e585e40ad190601381f1e1.svg";
export { ForwardRef as ReactComponent };